import React from "react";
import { Modal, Button, Image, Header } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import logoBauerMedia from "assets/BMG_Outdoor.png";
//import LanguageMenu from "components/LanguageMenu/LanguageMenu";

const PrivacyPolicy = ({ open, onClose }) => {
  const { t } = useTranslation("common");

  return (
    <Modal open={open} onClose={onClose} size="large">
      <Modal.Content
        scrolling
        className="privacy-policy-content"
        style={{ display: "flex", justifyContent: "center", maxHeight: "none" }}
      >
        <div style={{ padding: "1em", maxWidth: "800px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Image size="small" src={logoBauerMedia} alt={"Bauer Media Outdoor logo"} />
            {/*<LanguageMenu />*/}
          </div>
          <Header as="h1" style={{ paddingTop: "2rem" }}>
            {t("privacyPolicy.title")}
          </Header>
          <Header as="h2" style={{ paddingTop: "2rem" }}>
            {t("privacyPolicy.subtitle")}
          </Header>
          {/* Main Title & Contents */}
          <Header as="h3">{t("privacyPolicy.contents")}</Header>
          <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
            <li>
              <a href="#scope">{t("privacyPolicy.scope.title")}</a>
            </li>
            <li>
              <a href="#contact">{t("privacyPolicy.contact.title")}</a>
            </li>
            <li>
              <a href="#dataProcessing">{t("privacyPolicy.dataProcessing.title")}</a>
            </li>
            <li>
              <a href="#legalBasis">{t("privacyPolicy.legalBasis.title")}</a>
            </li>
            <li>
              <a href="#sharing">{t("privacyPolicy.sharing.title")}</a>
            </li>
            <li>
              <a href="#overseasTransfer">{t("privacyPolicy.overseasTransfer.title")}</a>
            </li>
            <li>
              <a href="#retention">{t("privacyPolicy.retention.title")}</a>
            </li>
            <li>
              <a href="#rights">{t("privacyPolicy.rights.title")}</a>
            </li>
            <li>
              <a href="#security">{t("privacyPolicy.security.title")}</a>
            </li>
            <li>
              <a href="#dpoContact">{t("privacyPolicy.dpoContact.title")}</a>
            </li>
            <li>
              <a href="#supervisory">{t("privacyPolicy.supervisory.title")}</a>
            </li>
            <li>
              <a href="#changes">{t("privacyPolicy.changes.title")}</a>
            </li>
          </ul>
          <Header as="h2">{t("privacyPolicy.productsAndServicesTitle")}</Header>
          {/* Scope */}
          <Header as="h3" id="scope">
            {t("privacyPolicy.scope.title")}
          </Header>
          <p>{t("privacyPolicy.scope.paragraph1")}</p>
          <p>{t("privacyPolicy.scope.paragraph2")}</p>
          <p>{t("privacyPolicy.scope.paragraph3")}</p>
          <p>{t("privacyPolicy.scope.paragraph4")}</p>
          {/* Contact Information */}
          <Header as="h3" id="contact">
            {t("privacyPolicy.contact.title")}
          </Header>
          <p>{t("privacyPolicy.contact.paragraph1")}</p>
          <p>{t("privacyPolicy.contact.paragraph2")}</p>
          <p>
            {t("privacyPolicy.contact.paragraph3")}{" "}
            <a href="mailto:dpo@bauermediaoutdoor.com">dpo@bauermediaoutdoor.com</a>
          </p>
          {/* Data Collection */}
          <Header as="h3" id="dataProcessing">
            {t("privacyPolicy.dataProcessing.title")}
          </Header>
          <p>{t("privacyPolicy.dataProcessing.paragraph1")}</p>
          <p>{t("privacyPolicy.dataProcessing.paragraph2")}</p>
          <ul>
            <li>{t("privacyPolicy.dataProcessing.list.nameAndJobTitle")}</li>
            <li>{t("privacyPolicy.dataProcessing.list.company")}</li>
            <li>{t("privacyPolicy.dataProcessing.list.contactInformation")}</li>
            <li>{t("privacyPolicy.dataProcessing.list.loginDetails")}</li>
            <li>{t("privacyPolicy.dataProcessing.list.informationForServices")}</li>
            <li>{t("privacyPolicy.dataProcessing.list.otherInformation")}</li>
          </ul>
          <p>{t("privacyPolicy.dataProcessing.paragraph3")}</p>
          {/* Automatic Collection */}
          <p>
            <u>{t("privacyPolicy.automaticCollection.title")}</u>
          </p>
          <p>{t("privacyPolicy.automaticCollection.paragraph")}</p>
          {/* Purpose */}
          <Header as="h3">{t("privacyPolicy.purpose.title")}</Header>
          <p>{t("privacyPolicy.purpose.paragraph1")}</p>
          <ul>
            <li>{t("privacyPolicy.purpose.paragraph2")}</li>
            <li>{t("privacyPolicy.purpose.paragraph3")}</li>
            <li>{t("privacyPolicy.purpose.paragraph4")}</li>
          </ul>
          {/* Legal Basis */}
          <Header as="h3" id="legalBasis">
            {t("privacyPolicy.legalBasis.title")}
          </Header>
          <p>{t("privacyPolicy.legalBasis.paragraph1")}</p>
          <Header as="h4">{t("privacyPolicy.legalBasis.consent.title")}</Header>
          <p>{t("privacyPolicy.legalBasis.consent.paragraph")}</p>
          <Header as="h4">{t("privacyPolicy.legalBasis.legitimatePurpose.title")}</Header>
          <p>{t("privacyPolicy.legalBasis.legitimatePurpose.paragraph")}</p>
          {/* Sharing */}
          <Header as="h3" id="sharing">
            {t("privacyPolicy.sharing.title")}
          </Header>
          <p>{t("privacyPolicy.sharing.paragraph1")}</p>
          <ul>
            <li>{t("privacyPolicy.sharing.list.businessPartners")}</li>
            <li>{t("privacyPolicy.sharing.list.groupCompanies")}</li>
            <li>{t("privacyPolicy.sharing.list.serviceProviders")}</li>
          </ul>
          {/* Overseas Transfer */}
          <Header as="h3" id="overseasTransfer">
            {t("privacyPolicy.overseasTransfer.title")}
          </Header>
          <p>{t("privacyPolicy.overseasTransfer.paragraph")}</p>
          {/* Data Retention */}
          <Header as="h3" id="retention">
            {t("privacyPolicy.retention.title")}
          </Header>
          <p>{t("privacyPolicy.retention.paragraph1")}</p>
          <p>{t("privacyPolicy.retention.paragraph2")}</p>
          {/* Data Subject Rights */}
          <Header as="h3" id="rights">
            {t("privacyPolicy.rights.title")}
          </Header>
          <p>{t("privacyPolicy.rights.paragraph1")}</p>
          <ul>
            <li>{t("privacyPolicy.rights.list.access")}</li>
            <li>{t("privacyPolicy.rights.list.rectification")}</li>
            <li>{t("privacyPolicy.rights.list.objection")}</li>
            <li>{t("privacyPolicy.rights.list.informed")}</li>
            <li>{t("privacyPolicy.rights.list.restrictProcessing")}</li>
            <li>{t("privacyPolicy.rights.list.portability")}</li>
            <li>{t("privacyPolicy.rights.list.automatedDecisionMaking")}</li>
            <li>{t("privacyPolicy.rights.list.erasure")}</li>
          </ul>
          <p>{t("privacyPolicy.rights.paragraph2")}</p>
          <p>
            {t("privacyPolicy.rights.paragraph3")}{" "}
            <a href="mailto:dpo@bauermediaoutdoor.com">dpo@bauermediaoutdoor.com</a>.
          </p>
          {/* Security */}
          <Header as="h3" id="security">
            {t("privacyPolicy.security.title")}
          </Header>
          <p>{t("privacyPolicy.security.paragraph1")}</p>
          <p>{t("privacyPolicy.security.paragraph2")}</p>
          {/* DPO Contact */}
          <Header as="h3" id="dpoContact">
            {t("privacyPolicy.dpoContact.title")}
          </Header>
          <p>
            {t("privacyPolicy.dpoContact.paragraph1")}{" "}
            <a href="mailto:dpo@bauermediaoutdoor.com">dpo@bauermediaoutdoor.com</a>.{" "}
          </p>
          <p>{t("privacyPolicy.dpoContact.paragraph2")}</p>
          <p>
            <strong>{t("privacyPolicy.dpoContact.addressTitle")}</strong>
            <br />
            {t("privacyPolicy.dpoContact.addressLine1")}
            <br />
            {t("privacyPolicy.dpoContact.addressLine2")}
            <br />
          </p>
          {/* Supervisory */}
          <Header as="h3" id="supervisory">
            {t("privacyPolicy.supervisory.title")}
          </Header>
          <p>{t("privacyPolicy.supervisory.paragraph1")}</p>
          <p>
            {t("privacyPolicy.supervisory.paragraph2")}{" "}
            <a href="https://www.ico.org.uk" target="_blank" rel="noopener noreferrer">
              www.ico.org.uk
            </a>
          </p>
          {/* Changes */}
          <Header as="h3" id="changes">
            {t("privacyPolicy.changes.title")}
          </Header>
          <p>{t("privacyPolicy.changes.paragraph")}</p>
          <p>
            <strong>{t("privacyPolicy.lastUpdated")}</strong>
          </p>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          style={{
            color: "white",
            backgroundColor: "#4700a3",
          }}
          onClick={onClose}
        >
          {t("close")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default PrivacyPolicy;
